module.exports = __webpack_public_path__ + "media/images/pages/fcr/lab-1-1a0b24d842b0764e8862b4365a1fc581.png";